import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { CommonLayout } from '~/atomic/layout/CommonLayout';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { Contacts } from '~/atomic/page/contacts/Contacts';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { createStore, RootState } from '~/store';

const ContactsPage: NextPage & LayoutType = () => {
  const title = 'Контакты | Произведения авторов полностью на Bookriver';
  const description = 'Контакты — литературно-издательская площадка Bookriver'
  + '⭐ Серии книг ⭐ Полные циклы произведений ⭐ Комментарии и отзывы читателей'
  + '⭐ Скачать произведения полностью в формате fb2 ✉'
  + 'Найдите интересную книгу на нашем сайте и читайте удобно онлайн';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.contacts.isPublic}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.contacts.url,
      }}
      content={(<Contacts />)}
    />
  );
};

ContactsPage.getLayout = (page) => (
  <CommonLayout>{ page }</CommonLayout>
);

export const getServerSideProps: GetServerSideProps<
{ state: RootState; },
{ genres: string[]; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  const isLoggedIn = await checkAuthToken(context, dispatch);

  const state = store.getState();
  return { props: { state } };
};

export default ContactsPage;
